import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { getItem, getLocalLanguage, setLocalLanguage } from 'helpers/localstorage.helpers'
import { getAllSiteinfo } from 'redux-thunk/thunk/gameSetting'
import { LANGUAGES, LANGUAGESLIST, SHOW_SIDE_NAV } from 'constants/index'
import { earthIcon } from 'components/ui-kit/Icons/png/index'
// import { NewClutchLogoIcon } from 'components/ui-kit/Icons/svg/index'
import './footer.scss'
import { useTranslation } from 'react-i18next'
import footerLogo from '../../ui-kit/Icons/png/moola-hub-logo.png'
import { setSystemLanguage } from 'redux-thunk/redux/slices/gameSetting.slice'
import i18n from 'translation/index'

const Footer = () => {
  const [currentLanguage, setCurrentLanguage] = useState(LANGUAGES[0].label)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { siteInfo } = useSelector(state => state.user)
  const copyRightYear = new Date().getFullYear()

  const showSideNav = getItem(SHOW_SIDE_NAV)

  useEffect(() => {
    dispatch(getAllSiteinfo())
    const lang = getLocalLanguage()
    if (!lang) {
      setCurrentLanguage(LANGUAGESLIST.en)
      setLocalLanguage(LANGUAGES[0].languageCode)
      dispatch(setSystemLanguage('en'))
    } else {
      setCurrentLanguage(LANGUAGESLIST[lang])
      dispatch(setSystemLanguage(lang))
    }
    // getLocalLanguage()
    // console.log('getLocalLanguage(): ', getLocalLanguage())
  }, [])

  const setLanguage = (language) => {
    console.log('language: ', typeof LANGUAGESLIST.language)
    setCurrentLanguage(LANGUAGESLIST[language])
    setLocalLanguage(language)
    dispatch(setSystemLanguage(LANGUAGESLIST[language]))
    i18n.changeLanguage(language)
    console.log(`Language set to: ${language}`)
  }

  // useEffect(() => {

  // }, [systemLanguage])

  return (
    <footer className={`mt-3 ${!showSideNav ? 'sidebar-close' : ''}`}>
      <div className='footer-top'>
        <div className='content-wrapper custom-spacer'>
          <div className='row'>
            <div className='col-xl-4 col-lg-4 col-md-12 order-3 order-lg-0'>
              <div className='footer-about my-3'>
                <div className='footer-logo'>
                  <img src={footerLogo} alt='Logo' width='200px' />
                </div>
                {/* <p className='m-0'>
                  {t('copyrightText')}
                </p> */}
              </div>
            </div>
            <div className='col-xl-3 col-lg-3 col-md-4 col-sm-6 order-0 order-lg-1'>
              <div className='footer-linking d-flex justify-content-between my-3'>
                <h4 className='m-0'>{t('platform')}</h4>
                <ul className='m-0'>
                  <li>
                    <NavLink to='#'>{t('support')}</NavLink>
                  </li>
                  <li>
                    <NavLink to='#'>{t('faq')}</NavLink>
                  </li>
                  <li>
                    <NavLink to='#'>{t('partnershipProgram')}</NavLink>
                  </li>
                  <li>
                    <NavLink to='#'>{t('blog')}</NavLink>
                  </li>
                  <li>
                    <NavLink to='#'>{t('helpCenter')}</NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-xl-3 col-lg-3 col-md-4 col-sm-6 order-1 order-lg-2'>
              <div className='footer-linking d-flex justify-content-between my-3'>
                <h4 className='m-0'>{t('aboutUs')}</h4>
                <ul className='m-0'>
                  {siteInfo?.filter(el => el.cmsSection === 'aboutUs')?.map(el =>
                    <li key={el.id}>
                      <NavLink to={`/site-info/${el.slug}`}>{el.title}</NavLink>
                    </li>)}
                </ul>
              </div>
            </div>
            <div className='col-xl-2 col-lg-2 col-md-4 col-sm-6 order-2 order-lg-3'>
              <div className='footer-linking d-flex justify-content-between my-3'>
                <h4 className='m-0'>{t('community')}</h4>
                <ul className='m-0'>
                  <li>
                    <NavLink to='#'>{t('facebook')}</NavLink>
                  </li>
                  <li>
                    <NavLink to='#'>{t('twitter')}</NavLink>
                  </li>
                  <li>
                    <NavLink to='#'>{t('instagram')}</NavLink>
                  </li>
                  <li>
                    <NavLink to='#'>{t('discord')}</NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className='language-wrap d-flex justify-content-between align-items-center'>
            <p className='mb-0'>
              © {copyRightYear} moolahub.bet {t('copyRights')}.
            </p>
            <div className='dropdown language-btn'>
              <button
                className='btn btn-secondary dropdown-toggle shadow-none'
                type='button'
                id='dropdownMenuButton1'
                data-bs-toggle='dropdown'
                aria-expanded='false'
                value={currentLanguage}
              >
                <img src={earthIcon} alt='Earth' height='15' width='15' />
                {currentLanguage}
              </button>
              <ul className='dropdown-menu' aria-labelledby='dropdownMenuButton1'>
                <li>
                  <div className='dropdown-item' href='#' onClick={() => setLanguage('en')}>
                    {t('english')}
                  </div>
                </li>
                <li>
                  <div className='dropdown-item' href='#' onClick={() => setLanguage('es')}>
                    {t('spanish')}
                  </div>
                </li>
                <li>
                  <div className='dropdown-item' href='#' onClick={() => setLanguage('fr')}>
                    {t('french')}
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className='py-4 footer-text mt-4'>
            <p className='mb-0 pb-0'>
              {t('gameFooterLicenseText')}
            </p>
          </div>
        </div>
      </div>
      <div className='footer-bottom-linking d-md-flex justify-content-center align-items-center'>
        <p className='m-0'>
          {t('support')}
          <NavLink to='#'>support@moolahub.bet</NavLink>
        </p>
        <p className='m-0'>
          {t('partners')}
          <NavLink to='#'>partners@moolahub.bet</NavLink>
        </p>
        <p className='m-0'>
          {t('legal')}
          <NavLink to='#'>legal@moolahub.bet</NavLink>
        </p>
      </div>
    </footer>
  )
}

export default React.memo(Footer)
